import { Container } from '@material-ui/core';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Auth from './components/Auth/Auth';
import useStyles from './styles'

const App = () => {
  const { container } = useStyles();

  return (
    <BrowserRouter>
      {/* Container is used to ensure to center everything */}
      <Container className={container} maxWidth="xl">
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/auth' element={<Auth />} />
        </Routes>
      </Container>
    </BrowserRouter>
  );
}

export default App;
